import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { createFrontendModule, TranslationBlueprint } from '@backstage/frontend-plugin-api';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';

const coreComponentsMessages = createTranslationMessages({
  ref: coreComponentsTranslationRef,
  full: true,
  messages: {
    'signIn.title': 'Entrar',
    'signIn.loginFailed': 'Login Falhou',
    'signIn.customProvider.title': 'Usuário Customizado',
    'signIn.customProvider.subtitle': 'Digite seu ID de usuário e credenciais.\n Esta seleção não será armazenada.',
    'signIn.customProvider.userId': 'ID do Usuário',
    'signIn.customProvider.tokenInvalid': 'Não é um token JWT OpenID Connect válido',
    'signIn.customProvider.continue': 'Continuar',
    'signIn.customProvider.idToken': 'ID do Token (opcional)',
    'signIn.guestProvider.title': 'Convidado',
    'signIn.guestProvider.subtitle': 'Entrar como Usuário Convidado.\n Você não terá uma identidade verificada, portanto algumas funcionalidades podem estar indisponíveis.',
    'signIn.guestProvider.enter': 'Entrar',
    'skipToContent': 'Pular para conteúdo',
    'copyTextButton.tooltipText': 'Texto copiado para a área de transferência',
    'simpleStepper.reset': 'Resetar',
    'simpleStepper.finish': 'Concluir',
    'simpleStepper.next': 'Próximo',
    'simpleStepper.skip': 'Pular',
    'simpleStepper.back': 'Anterior',
    'errorPage.subtitle': 'ERRO {{status}} {{statusMessage}}',
    'errorPage.title': 'Algo deu errado!',
    'errorPage.goBack': 'Voltar',
    'errorPage.showMoreDetails': 'Mostrar mais detalhes',
    'errorPage.showLessDetails': 'Mostrar menos detalhes',
    'emptyState.missingAnnotation.title': 'Anotação Não encontrada',
    'emptyState.missingAnnotation.actionTitle': 'Adicione a anotação ao YAML do seu componente como destacado no exemplo abaixo',
    'emptyState.missingAnnotation.readMore': 'Ler mais',
    'supportConfig.default.title': 'Suporte não configurado',
    'supportConfig.default.linkTitle': 'Adicione a chave de configuração `app.support`',
    'errorBoundary.title': 'Por favor contate {{slackChannel}} para auxílio',
    'oauthRequestDialog.title': 'Login Necessário',
    'oauthRequestDialog.authRedirectTitle': 'Isto irá redirecionar para o login OAuth.',
    'oauthRequestDialog.login': 'Entrar',
    'oauthRequestDialog.rejectAll': 'Rejeitar Todos',
    'oauthRequestDialog.message': 'Entre para permitir o acesso de {{appTitle}} às APIs e identidades de {{provider}}',
    'supportButton.title': 'Suporte',
    'supportButton.close': 'Fechar',
    'table.filter.title': 'Filtros',
    'table.filter.clearAll': 'Limpar todos',
    'table.filter.placeholder': 'Todos os resultados',
    'table.body.emptyDataSourceMessage': 'Sem resultados para mostrar',
    'table.pagination.firstTooltip': '`rimeira Página',
    'table.pagination.labelDisplayedRows': '{from}-{to} de {count}',
    'table.pagination.labelRowsSelect': 'linhas',
    'table.pagination.lastTooltip': 'Última Página',
    'table.pagination.nextTooltip': 'Próxima Página',
    'table.pagination.previousTooltip': 'Página Anterior',
    'table.toolbar.search': 'Filtrar',
    'table.header.actions': 'Ações',
    'alertDisplay.message_one': '({{ count }} nova mensagem)',
    'alertDisplay.message_other': '({{ count }} novas mensagens)',
    'autoLogout.stillTherePrompt.title': 'Desconectando por inatividade',
    'autoLogout.stillTherePrompt.buttonText': 'Sim! Não desconectar',
    'dependencyGraph.fullscreenTooltip': 'Alternar tela cheia',
    'proxiedSignInPage.title': 'Você não parece estar logado. Por favor tente reiniciar a página do navegador.'
  },
});

export const coreComponentsTranslationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    TranslationBlueprint.make({
      name: 'core-components-overrides',
      params: {
        resource: coreComponentsMessages
      },
    }),
  ]
})